// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.emap-flow-next-step-m .emap-flow-next-step-item {\n  border-bottom: 1px solid #EDF2FB;\n}\n.selected {\n  color: #323233;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.checkbox-group-container {\n  height: 266px;\n  overflow: auto;\n}\n", ""]);
// Exports
module.exports = exports;
